module.exports = __webpack_public_path__ + "img/FK.4f14ebbc.png";